// TODO: Refactor this code


let button = document.getElementById('id_photo');
let image = document.getElementsByClassName('change__image');


if (button) {
    button.onchange = function () {
        var reader = new FileReader();

        reader.onload = function (e) {
            // get loaded data and render thumbnail.
            document.getElementById('image').src = e.target.result;
        };

        // read the image file as a data URL.
        reader.readAsDataURL(this.files[0]);
    };
}


if (image) {
    image.onclick = function() {
        document.getElementById('id_photo').click();
    };
}



// WEBPACK FOOTER //
// ./src/my_artis/js/components/change.js